import type { ImDashboardSummary } from "@ark/contracts";

export interface ImUnreadBadge {
  label: string;
  text: string;
  unknown?: boolean;
}

export function imBadge(
  summary: ImDashboardSummary | undefined,
): ImUnreadBadge | undefined {
  if (!summary) {
    return { label: "消息未读状态暂不可用", text: "·", unknown: true };
  }
  if (summary.readState !== "fresh" || summary.totalUnreadCount == null) {
    return { label: "消息未读状态正在同步", text: "·", unknown: true };
  }
  if (summary.totalUnreadCount <= 0) return undefined;
  return summary.unreadCountCapped
    ? { label: "99 条以上未读消息", text: "99+" }
    : {
        label: `${summary.totalUnreadCount} 条未读消息`,
        text: String(summary.totalUnreadCount),
      };
}
